import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../spinner/Spinner.component';
import { Dimmer } from '../dimmer/Dimmer.component';

@customElement('lr-loading-overlay')
export class LoadingOverlay extends Dimmer {
    active = true;
    renderElement() {
        return html`<lr-spinner></lr-spinner> `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'lr-loading-overlay': LoadingOverlay;
    }
}
